<script lang="ts">
  import { fade } from "svelte/transition";
  import { assets } from "$app/paths";

  /**
   * Icon string identifier
   */
  export let icon: string;

  /**
   * Icon style: `rounded`, `filled`, `outline`, `sharp`
   */
  export let iconStyle: string = "rounded";

  export let color: string = "var(--on-background)";

  /**
   * Sizes available: `small`, `medium`, `large`
   */
  export let size: string = "small";

  // If true, will use icons from static/icons
  export let customIcon = false;

  export let withBorder = false;

  export let switchable = false;

  export let lazyLoad = false;

  let styleClass: string = "material-icons-round";

  switch (iconStyle) {
    case "rounded":
    default:
      styleClass = "material-icons-round";
      break;
    case "outline":
      styleClass = "material-icons-outlined";
      break;
  }
</script>

<style lang="scss">
  .icon {
    vertical-align: middle;
  }
  .icon--extra-small {
    font-size: 12.5px;
  }
  .icon--small {
    font-size: 24px;
  }
  .icon--medium {
    font-size: 32px;
  }
  .icon--large {
    font-size: 48px;
  }
  .custom-icon {
    &--small {
      img {
        width: 24px;
      }
    }
    &--medium {
      img {
        width: 32px;
      }
    }
    &--large {
      img {
        width: 48px;
      }
    }
  }

  .withBorder {
    border-width: 1px;
    border-style: solid;
    border-radius: 50%;
    padding: 4px;

    @include retina {
      border-width: 0.5px;
    }
  }
</style>

{#if customIcon}
  <span
    class="custom-icon icon custom-icon--{size}"
    class:withBorder
    style={`${withBorder && `border-color: ${color};`}`}
    aria-hidden="true"
  >
    <img
      loading="lazy"
      src={`${assets}/icons/${icon}.svg`}
      alt={`${icon} icon`}
      {...lazyLoad && { loading: "lazy" }}
    />
  </span>
{:else if switchable}
  <!-- 
  Adding role="heading" and a level to suppress accessibe scanner.  
  Its a false positive, and the aria-hidden should hide it from screen
  readers anyway, as an icon is not descriptive content.
-->
  {#key icon}
    <span
      class={`icon icon--${size} ${styleClass}`}
      class:withBorder
      style={`position: absolute; color: ${color}; ${
        withBorder && `border-color: ${color};`
      }`}
      transition:fade={{ duration: 200 }}
      aria-hidden="true"
      role="heading"
      aria-level="2"
    >
      {icon}
    </span>
  {/key}
{:else}
  <span
    class={`icon icon--${size} ${styleClass}`}
    class:withBorder
    style={`color: ${color}; ${withBorder && `border-color: ${color};`}`}
    aria-hidden="true"
    role="heading"
    aria-level="2"
  >
    {icon}
  </span>
{/if}
